module.exports = __webpack_public_path__ + "static/WolfeLogo-4a29a4926dd68ce9af631909be125338.png";